// feeds HOME 
// feeds PODCASTS
// feeds OPINION
// feeds RESOURCES
// feeds PAGENOTFOUND
import React from "react";
import TLNyoutubeBtnEmbed from "../src/assets/images/TLNyoutubeBtnEmbed";
import TLNfbBtnEmbed from "../src/assets/images/TLNfbBtnEmbed";
import MSfbBtnEmbed from "./assets/images/MikeShelbyFBEmbed";
// import Considerations from "./Considerations";
// <Considerations resource={resource}/>
// import FbLikesTLN from "./FbLikesTLN";
// removed YT <div className="g-ytsubscribe asideDiv" data-channelid="UCbiafnj1CoWFT5R4QNLu20Q" data-layout="default" data-count="default"></div>
function AsideContent2({resource}) {

    const EmbedImage = resource.image; 
    const BtnImage = TLNyoutubeBtnEmbed;
    const FBBtnImage = TLNfbBtnEmbed;
    const MSBtnImage = MSfbBtnEmbed
    return (
        <>
        <div className="embedImage">    
        <EmbedImage />
    	</div>
        <h2 className="sectionHeader">Follow Us</h2>
    	<div className="asideMain">
            <p>Official <b>YouTube</b> Channel</p>
            <a href="https://www.youtube.com/@TrueLibertyNorth" title="TrueLibertyNorth YouTube"  
                      target="_blank" rel="noreferrer" className="rLinks">
                <div className="btnImage">    
                    <BtnImage />
                </div>
            </a>
            <hr className="asideDiv" aria-hidden />
            <p>Official <b>Facebook</b> Page</p>
            <a href="https://www.facebook.com/TrueLibertyNorth" title="True Liberty North Facebook"  
                      target="_blank" rel="noreferrer" className="rLinks">
                <div className="btnImage">    
                    <FBBtnImage />
                </div>
            </a>
            <hr className="asideDiv" aria-hidden />
            <p>Mike Shelby <b>Facebook</b></p>
            <a href="https://www.facebook.com/profile.php?id=100013913299532" title="Mike Shelby Facebook"  
                      target="_blank" rel="noreferrer" className="rLinks">
                <div className="btnImage">    
                    <MSBtnImage />
                </div>
            </a>
        </div>
        </>
    );
  };
  export default AsideContent2;